<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Créer une nouvelle structure</strong>
          </div>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="libelle"><strong>Libellé : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="libelle" v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.libelle }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="libelle_technique"><strong>Libellé technique : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="libelle_technique" v-model="libelle_technique" :class="{hasError: errors.libelle_technique !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.libelle_technique }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="logo"><strong>Logo : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-file id="logo" placeholder="Sélectionner le Logo"
                          class="file-input"
                          drop-placeholder="Déposer le fichier ici..."
                          browse-text="Parcourir"
                          :state="errors.attachment !== '' ? false : null"
                          @change="addFile($event)">
              </b-form-file>
              <span class='field-error'>{{ errors.attachment }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="adresse1"><strong>Adresse 1 : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="text" id="adresse1" v-model="adresse1" :class="{hasError: errors.adresse1 !== ''}"></b-form-input>
              <!-- <span class='field-error'>{{ errors.adresse1 }}</span> -->
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="adresse2"><strong>Adresse 2 : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="text" id="adresse2" v-model="adresse2" :class="{hasError: errors.adresse2 !== ''}"></b-form-input>
              <!-- <span class='field-error'>{{ errors.adresse2 }}</span> -->
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="code_postal"><strong>Code postal : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="text" id="code_postal" v-model="code_postal" :class="{hasError: errors.code_postal !== ''}"></b-form-input>
              <!-- <span class='field-error'>{{ errors.code_postal }}</span> -->
            </b-col>
            <b-col sm="3">
              <label for="ville"><strong>Ville : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="text" id="ville" v-model="ville" :class="{hasError: errors.ville !== ''}"></b-form-input>
              <!-- <span class='field-error'>{{ errors.ville }}</span> -->
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="ordre"><strong>Ordre : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-input id="ordre" type="number" min="0" v-model="ordre"></b-form-input>
            </b-col>
          </b-row>

          <div class="mt-5" slot="footer">
            <b-button type="button" @click="returnBack" size="md" variant="secondary">
              <i class="fa fa-arrow-left"/> Liste des structures
            </b-button>
            <b-button type="button" @click="saveStructure" size="md" class="pull-right" variant="primary">
              <i class="fa fa-save"/> Enregistrer
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";
  import {isEmpty, permittedImageExtension} from "@/utils/fileHelper";
  export default {
    name: "Add",
    data() {
      return {
        libelle: "",
        libelle_technique: "",
        attachment: '',
        adresse1: "",
        adresse2: "",
        code_postal: "",
        ville: "",
        ordre: 0,
        errors: {
          libelle: "",
          libelle_technique: "",
          attachment: '',
          adresse1: "",
          adresse2: "",
          code_postal: "",
          ville: "",
        },
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      saveStructure() {
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          let self = this;
          let formData = new FormData();
          formData.append('libelle', this.libelle);
          formData.append('libelle_technique', this.libelle_technique);
          formData.append('file', this.attachment);
          formData.append('adresse1', this.adresse1);
          formData.append('adresse2', this.adresse2);
          formData.append('code_postal', this.code_postal);
          formData.append('ville', this.ville);
          formData.append('ordre', this.ordre);

          this.$axios
            .post("/administration/structures", formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Création avec succès",
                text: "La structure a été bien crée",
                showConfirmButton: false,
                timer: 3700
              });
              this.clearFields();
              setTimeout(() => this.returnBack(), 3800);
              this.returnBack()
            })
            .catch((error) => {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: error,
                showConfirmButton: false,
                timer: 4000
              });
            });
        }
      },
      addFile(event) {
        this.attachment = event.target.files[0]
      },
      returnBack() {
        this.$router.push({path: "/administration/structures"});
      },
      validateData() {
        this.clearErrors()
        let valid = true;
        if (this.libelle === "") {
          this.errors.libelle = "Le libellé est obligatoire";
          valid = false;
        }
        if (this.libelle_technique === "") {
          this.errors.libelle_technique = "Le libellé technique est obligatoire";
          valid = false;
        }
        // if (this.adresse1 === "") {
        //   this.errors.adresse1 = "L'adresse 1 est obligatoire";
        //   valid = false;
        // }
        // if (this.adresse2 === "") {
        //   this.errors.adresse2 = "L'adresse 2 est obligatoire";
        //   valid = false;
        // }
        // if (this.code_postal === "") {
        //   this.errors.code_postal = "Le code postal est obligatoire";
        //   valid = false;
        // }
        // if (this.ville === "") {
        //   this.errors.ville = "Le nom de la ville est obligatoire";
        //   valid = false;
        // }
        if (!isEmpty(this.attachment)) {
          if (!_.includes(permittedImageExtension, this.attachment.name.split('.').pop().toLowerCase())) {
            valid = false;
            this.errors.attachment = "Le Format de fichier n'est pas autorisé (formats autorisés : "+permittedImageExtension.join(', ')+")";
          }
        }
        return valid;
      },
      clearErrors() {
        this.errors.libelle = "";
        this.errors.libelle_technique = "";
        this.errors.attachment = ""
        // this.errors.adresse1 = "";
        // this.errors.adresse2 = "";
        // this.errors.code_postal = "";
        // this.errors.ville = "";
      },
      clearFields() {
        this.libelle = '';
        this.libelle_technique = '';
        this.attachment = '';
        this.adresse1 = '';
        this.adresse2 = '';
        this.code_postal = '';
        this.ville = '';
        this.ordre = '';
      },
    }
  }
</script>
